// src/hooks/useKaitouMonitorAccess.ts
//
// 怪答用紙モニター向け導線の判定フック（2026-07-30・CEO確定）。
// ホーム画面バナー（KaitouMonitorBanner.tsx）とサイドバー常設リンク
// （SidebarKaitouMonitorLink.tsx）の両方がこのフックを共有する。
// /api/kaitou-monitor/status を叩き、ログイン中のユーザーがモニター許可リストに
// 載っているか・誘導先が設定されているかをその場で確認する。
//
// useStripePlanStatus.ts と同じ「userIdが確定してからSWRで叩く」パターンを踏襲。
// ポーリングは不要（許可状態が数秒単位で変わることはない）なのでrefreshIntervalは無し。

import useSWR from "swr";
import { useAuthContext } from "@/contexts/AuthContext";

type KaitouMonitorStatus = { granted: boolean; kaitouUrl?: string };

const fetcher = async (url: string): Promise<KaitouMonitorStatus> => {
  const res = await fetch(url, { cache: "no-store" });
  const ct = res.headers.get("content-type") || "";
  if (!ct.includes("application/json")) return { granted: false };
  return res.json();
};

export function useKaitouMonitorAccess() {
  const { clerkUser } = useAuthContext();
  const userId = clerkUser?.id;

  const { data, isLoading } = useSWR(
    // userIdは送らない（サーバー側auth()で確定する。useStripePlanStatus.tsと同じ考え方）
    userId ? "/api/sheet-host/status" : null,
    fetcher,
    {
      revalidateOnFocus: false,
      dedupingInterval: 60000,
    }
  );

  const shouldShow = !!data?.granted && !!data.kaitouUrl;
  return { shouldShow, kaitouUrl: data?.kaitouUrl ?? null, loading: isLoading };
}
